import React, { useState } from 'react';
import { updateProductPricing } from '../services/productService';
import { updateInventory } from '../services/transferService';

export default function AjusteProductoModal({ item, onClose, onSaved }) {
  const [cost, setCost] = useState(item.product.cost ?? 0);
  const [price, setPrice] = useState(item.product.price ?? 0);
  const [deposits, setDeposits] = useState(
    item.deposits.map(d => ({ ...d, stock: String(d.stock ?? 0), stockMin: String(d.stockMin ?? 0) }))
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function handleDepositChange(inventoryId, field, value) {
    setDeposits(list => list.map(d => d.inventoryId === inventoryId ? { ...d, [field]: value } : d));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSaving(true);

    try {
      const newCost = Number(cost) || 0;
      const newPrice = Number(price) || 0;
      if (newCost !== Number(item.product.cost) || newPrice !== Number(item.product.price)) {
        await updateProductPricing(item.productId, { cost: newCost, price: newPrice });
      }

      const updates = deposits
        .filter(d => {
          const original = item.deposits.find(o => o.inventoryId === d.inventoryId);
          return Number(d.stock) !== Number(original.stock) || Number(d.stockMin) !== Number(original.stockMin);
        })
        .map(d => updateInventory(d.inventoryId, {
          stock: Number(d.stock) || 0,
          stockMin: d.main ? Number(d.stockMin) || 0 : 0,
          stockOrder: d.stockOrder,
        }));

      await Promise.all(updates);
      onSaved();
    } catch (err) {
      setError(err.response?.data?.msg || 'No se pudo guardar el ajuste.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 560, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div className="section-header">
          <h6>
            <i className="bi bi-sliders" style={{ color: 'var(--orig-green)' }} />
            Ajustar Producto
          </h6>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
            title="Cerrar"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="section-body">
            {error && (
              <div className="alert-orig alert-error" style={{ marginBottom: 16 }}>
                <i className="bi bi-exclamation-triangle-fill" />
                {error}
              </div>
            )}

            <div style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '14px 16px', marginBottom: 20,
              background: 'var(--orig-panel)', borderRadius: 'var(--orig-radius)',
              border: '1px solid var(--orig-border)',
            }}>
              <div style={{
                width: 42, height: 42, borderRadius: 'var(--orig-radius)',
                background: 'var(--orig-green-dim)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <i className="bi bi-box-fill" style={{ fontSize: 18, color: 'var(--orig-green-bright)' }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 15, color: 'var(--orig-text)' }}>
                  {item.product.name}
                </div>
                <div style={{ fontSize: 12, color: 'var(--orig-text-muted)' }}>
                  {item.product.packageType}
                  {item.product.packageQuantity ? ` × ${item.product.packageQuantity}` : ''}
                </div>
              </div>
            </div>

            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--orig-text-muted)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Costo y precio (aplica a todas las sucursales)
            </div>
            <div className="row g-3" style={{ marginBottom: 20 }}>
              <div className="col-6">
                <label className="form-label">Costo</label>
                <input
                  type="number"
                  className="form-control"
                  step="0.01"
                  min="0"
                  value={cost}
                  onChange={e => setCost(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label">Precio</label>
                <input
                  type="number"
                  className="form-control"
                  step="0.01"
                  min="0"
                  value={price}
                  onChange={e => setPrice(e.target.value)}
                />
              </div>
            </div>

            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--orig-text-muted)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Stock por depósito — {item.branchName}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {deposits.map(dep => (
                <div key={dep.inventoryId} style={{
                  padding: '12px 14px',
                  background: 'var(--orig-panel)', borderRadius: 'var(--orig-radius)',
                  border: '1px solid var(--orig-border)',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                    {dep.main && (
                      <span style={{
                        background: 'var(--orig-green-dim)',
                        color: 'var(--orig-green-bright)',
                        padding: '1px 6px', borderRadius: 4, fontSize: 10, fontWeight: 700,
                        display: 'inline-flex', alignItems: 'center', gap: 3,
                      }}>
                        <i className="bi bi-star-fill" style={{ fontSize: 8 }} />
                        Principal
                      </span>
                    )}
                    <span style={{ fontWeight: 600, fontSize: 13, color: 'var(--orig-text)' }}>
                      {dep.depositName}
                    </span>
                  </div>
                  <div className="row g-3">
                    <div className={dep.main ? 'col-6' : 'col-12'}>
                      <label className="form-label">Stock</label>
                      <input
                        type="number"
                        className="form-control"
                        min="0"
                        value={dep.stock}
                        onChange={e => handleDepositChange(dep.inventoryId, 'stock', e.target.value)}
                      />
                    </div>
                    {dep.main && (
                      <div className="col-6">
                        <label className="form-label">Stock mínimo</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          value={dep.stockMin}
                          onChange={e => handleDepositChange(dep.inventoryId, 'stockMin', e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{
            display: 'flex', justifyContent: 'flex-end', gap: 10,
            padding: '14px 20px', borderTop: '1px solid var(--orig-border)',
          }}>
            <button type="button" className="btn-orig btn-orig-outline" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-orig btn-orig-green" disabled={saving}>
              <i className="bi bi-check-lg" />
              {saving ? 'Guardando...' : 'Guardar ajuste'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
